var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72.55 67.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff462f;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    className: "cls-1",
    d: "M66.62,6.33a19.83,19.83,0,0,0-28-1c-.36.33-.71.68-1,1L36.28,7.69,35,6.33a19.86,19.86,0,0,0-28-1c-.35.34-.7.68-1,1a22.26,22.26,0,0,0,0,30.26l28.47,30a2.59,2.59,0,0,0,3.66.1h0a.94.94,0,0,0,.1-.1l28.46-30A22.26,22.26,0,0,0,66.62,6.33ZM62.86,33h0l-26.58,28L9.7,33A17,17,0,0,1,9.7,9.9a14.64,14.64,0,0,1,20.7-.83h0c.28.26.56.54.83.83l3.16,3.34a2.67,2.67,0,0,0,3.76,0L41.32,9.9A14.65,14.65,0,0,1,62,9.07c.29.27.57.54.84.83A16.86,16.86,0,0,1,62.86,33Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    className: "cls-1",
    d: "M62.86,33h0l-26.58,28L9.7,33A17,17,0,0,1,9.7,9.9a14.64,14.64,0,0,1,20.7-.83h0c.28.26.56.54.83.83l3.16,3.34a2.67,2.67,0,0,0,3.76,0L41.32,9.9A14.65,14.65,0,0,1,62,9.07c.29.27.57.54.84.83A16.86,16.86,0,0,1,62.86,33Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveActive);
export default __webpack_public_path__ + "static/media/save_active.fd6e70112ce4213922e3fe2356c2f7f9.svg";
export { ForwardRef as ReactComponent };